import React, { Fragment, useContext, useEffect, useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { AppContext } from "../context/AppContext";
import Masonry from "react-layout-masonry";
import { toast } from "react-toastify";
import * as Lu from "react-icons/lu";
import { PulseLoader } from "react-spinners";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Switch } from "antd";
import { MdKeyboardArrowLeft } from "react-icons/md";

import * as Fa from "react-icons/fa";

const EDIT_SECTIONS = {
  timings: {
    backTo: "/reservation-timings",
    title: "Edit reservation timings",
  },
  preferences: {
    backTo: "/reservation-preferences",
    title: "Edit reservation preferences",
  },
};

const allowedValues = {
  earlyBooking: ["any_time", "0", "1", "7", "10", "14", "30", "60", "90"],
  lateBooking: ["0", "1", "15", "30", "45", "60", "240", "1440"],
  lateCancel: ["0", "1", "30", "60", "120", "1440"],
  timeinterval: ["180", "120", "90", "60", "30", "15", "10", "5"],
  autoApprove: ["Enabled", "Disabled"],
  haveAdvance: ["Yes", "No"],
  advanceType: ["Total", "Table", "Chair"],
  otpVerify: ["Active", "Inactive"],
  reservationStatus: ["Enabled", "Disabled"],
  viewType: ["formView", "calendarView"],
  automatedMonthlyReport: ["Yes", "No"],
  reservationGuestAllow: ["Enabled", "Disabled"],
  reservationGuestOTPVerification: ["Enabled", "Disabled"],
};
const DAY_NUM = {
  monday: "1",
  tuesday: "2",
  wednesday: "3",
  thursday: "4",
  friday: "5",
  saturday: "6",
  sunday: "7",
};
const days = [
  "sunday",
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
];
const columns = { 0: 1, 576: 1, 768: 2, 992: 2, 1200: 2 };
function EditReservationSettings() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sectionParam = String(searchParams.get("section") || "")
    .trim()
    .toLowerCase();
  const editSection =
    sectionParam === "timings" ? "timings" : "preferences";
  const showTimings = editSection === "timings";
  const showPreferences = editSection === "preferences";
  const sectionMeta = EDIT_SECTIONS[editSection];

  const {
    reservationSettings,
    updateReservationSettings,
    reservSettingsLoading,
    fetchCurrentSettings,
    foodpageReservSettings,
    updateSettings,
    getSettings,
    reservFoodpageTiming,
    alterReservationTiming,
    reservationStatus,
  } = useContext(AppContext);
  const [updatedState, setUpdatedState] = useState({
    reservationStatus: "Enabled",
    earlyBooking: "any_time",
    lateBooking: "0",
    lateCancel: "0",
    timeinterval: "5",
    maxPartySize: 50,
    autoApprove: "Disabled",
    autoApproveChairLimit: 0,
    haveAdvance: "No",
    advanceAmount: 50,
    advanceType: "Total",
    minChairs: 1,
    otpVerify: "Inactive",
    viewType: "formView",
    automatedMonthlyReport: "No",
    monthlyReportEmail: "",
    reservationGuestAllow: "Disabled",
    reservationGuestOTPVerification: "Disabled",
  });
  const [isTimingUpdate, setIsTimingUpdate] = useState(false);
  const [reservationTiming, setReservationTiming] = useState({
    monday: null,
    tuesday: null,
    wednesday: null,
    thursday: null,
    friday: null,
    saturday: null,
    sunday: null,
  });
  const [timingChanged, setTimingChanged] = useState(false);
  const [updateLoading, setUpdateLoading] = useState(false);
  const [viewType, setViewType] = useState("formView");

  useEffect(() => {
    if (
      !reservFoodpageTiming ||
      typeof reservFoodpageTiming !== "object" ||
      Object.keys(reservFoodpageTiming).length === 0
    ) {
      return;
    }
    setReservationTiming(reservFoodpageTiming);
  }, [reservFoodpageTiming]);

  useEffect(() => {
    if (!foodpageReservSettings) return;
    setUpdatedState((prev) => ({
      ...prev,
      ...foodpageReservSettings,
      reservationStatus:
        reservationStatus ||
        foodpageReservSettings?.reservationStatus ||
        prev.reservationStatus ||
        "Enabled",
      minChairs: foodpageReservSettings?.minChairs ?? prev.minChairs ?? 1,
      automatedMonthlyReport:
        foodpageReservSettings?.automatedMonthlyReport ??
        prev.automatedMonthlyReport ??
        "No",
      monthlyReportEmail:
        foodpageReservSettings?.monthlyReportEmail ??
        prev.monthlyReportEmail ??
        "",
      viewType: foodpageReservSettings?.viewType || prev.viewType || "formView",
      reservationGuestAllow:
        foodpageReservSettings?.reservationGuestAllow ??
        prev.reservationGuestAllow ??
        "Disabled",
      reservationGuestOTPVerification:
        foodpageReservSettings?.reservationGuestOTPVerification ??
        prev.reservationGuestOTPVerification ??
        "Disabled",
    }));
    setViewType(foodpageReservSettings?.viewType || "formView");
  }, [foodpageReservSettings, reservationStatus]);

  const handleInputChange = (day, index, key, value) => {
    setReservationTiming((prev) => {
      const currentSlots = Array.isArray(prev?.[day]) ? prev[day] : [];
      const updatedDaySlots = [...currentSlots];

      while (updatedDaySlots.length <= index) {
        updatedDaySlots.push({
          slotId: "",
          day: DAY_NUM[day] || "",
          daytitle: day,
          openingTime: "00:00:00",
          closingTime: "00:00:00",
          status: "active",
        });
      }

      const existingSlot = updatedDaySlots[index] || {};

      const nextSlot = {
        slotId: existingSlot.slotId ?? "",
        day: existingSlot.day ?? (DAY_NUM[day] || ""),
        daytitle: existingSlot.daytitle ?? day,
        status: existingSlot.status === true ? "active" : "inactive",
        openingTime: existingSlot.openingTime ?? "00:00:00",
        closingTime: existingSlot.closingTime ?? "00:00:00",
        ...existingSlot,
        [key]: value,
      };

      // if (
      //   nextSlot.openingTime &&
      //   nextSlot.closingTime &&
      //   nextSlot.closingTime <= nextSlot.openingTime
      // ) {
      //   toast.error("End time must be greater than start time.");
      //   return prev;
      // }

      updatedDaySlots[index] = nextSlot;

      return {
        ...prev,
        [day]: updatedDaySlots,
      };
    });
    setTimingChanged(true);
  };

  function getDeviceID() {
    const key = "deviceID";
    let id = localStorage.getItem(key);
    if (!id) {
      id = crypto.randomUUID();
      localStorage.setItem(key, id);
    }
    return id;
  }

  function getDeviceName() {
    // You cannot read the actual PC name; this is an approximation
    const ua = navigator.userAgent;

    const isWindows = /Windows NT/i.test(ua);
    const isMac = /Macintosh/i.test(ua);
    const isLinux = /Linux/i.test(ua) && !/Android/i.test(ua);

    const browser = /Edg\//.test(ua)
      ? "Edge"
      : /Chrome\//.test(ua)
      ? "Chrome"
      : /Firefox\//.test(ua)
      ? "Firefox"
      : /Safari\//.test(ua)
      ? "Safari"
      : "Browser";

    const os = isWindows
      ? "Windows"
      : isMac
      ? "macOS"
      : isLinux
      ? "Linux"
      : "OS";

    return `${os} · ${browser}`;
  }

  function getGeo() {
    return new Promise((resolve) => {
      if (!navigator.geolocation) return resolve(null);

      navigator.geolocation.getCurrentPosition(
        (pos) =>
          resolve({
            lat: pos.coords.latitude,
            lon: pos.coords.longitude,
            accuracy: pos.coords.accuracy,
          }),
        () => resolve(null),
        { enableHighAccuracy: false, timeout: 8000, maximumAge: 60000 }
      );
    });
  }

  const addSlot = (day) => {
    setTimingChanged(true);
    setReservationTiming((prev) => {
      const currentSlots = Array.isArray(prev?.[day]) ? prev[day] : [];

      const newSlot = {
        slotId: "",
        day: DAY_NUM[day] || "",
        daytitle: day,
        openingTime: "",
        closingTime: "",
        status: "active",
      };

      return {
        ...prev,
        [day]: [...currentSlots, newSlot],
      };
    });
  };

  const deleteSlot = (day, index) => {
    setTimingChanged(true);
    setReservationTiming((prev) => {
      const currentSlots = Array.isArray(prev?.[day]) ? prev[day] : [];
      return {
        ...prev,
        [day]: currentSlots.filter((_, i) => i !== index),
      };
    });
  };

  const resetSlot = (day, index) => {
    setTimingChanged(true);
    setReservationTiming((prev) => {
      const currentSlots = Array.isArray(prev?.[day]) ? prev[day] : [];
      return {
        ...prev,
        [day]: currentSlots.map((slot, i) =>
          i === index ? { ...slot, openingTime: "", closingTime: "" } : slot
        ),
      };
    });
  };

  const onOtherSettingsChange = (e) => {
    const { name, value } = e.target;
    if (name === "advanceAmount") {
      setUpdatedState((prev) => ({
        ...prev,
        advanceAmount: value,
        otpVerify: "Inactive",
      }));
    } else {
      setUpdatedState((prev) => ({ ...prev, [name]: value }));
    }
  };

  // const handleExceptionChange = (index, field, value) => {
  //   setUpdatedState((prev) => {
  //     const updatedExceptions = prev.exceptions.map((exception, i) => {
  //       if (i === index) {
  //         if (field === "startDate" && value) {
  //           const startDate = new Date(value);

  //           const endDate = new Date(startDate);
  //           endDate.setHours(startDate.getHours() + 12);

  //           return {
  //             ...exception,
  //             startDate: value,
  //             endDate: endDate.toISOString().slice(0, 16), // Format as needed
  //           };
  //         }

  //         return { ...exception, [field]: value };
  //       }

  //       return exception;
  //     });

  //     return {
  //       ...prev,
  //       exceptions: updatedExceptions,
  //     };
  //   });
  // };

  const isEmpty = (v) =>
    v === undefined || v === null || (typeof v === "string" && v.trim() === "");

  const validateReservationSettings = (values) => {
    const errors = {};

    // earlyBooking
    if (isEmpty(values.earlyBooking)) {
      errors.earlyBooking =
        "Please select how early customers can make a booking.";
    } else if (
      !allowedValues.earlyBooking.includes(String(values.earlyBooking))
    ) {
      errors.earlyBooking = "Invalid early booking value.";
    }

    // lateBooking
    if (isEmpty(values.lateBooking)) {
      errors.lateBooking =
        "Please select how late customers can make a booking.";
    } else if (
      !allowedValues.lateBooking.includes(String(values.lateBooking))
    ) {
      errors.lateBooking = "Invalid late booking value.";
    }

    // lateCancel
    if (isEmpty(values.lateCancel)) {
      errors.lateCancel =
        "Please select how late customers can cancel a booking.";
    } else if (!allowedValues.lateCancel.includes(String(values.lateCancel))) {
      errors.lateCancel = "Invalid late cancellation value.";
    }

    // timeinterval
    if (isEmpty(values.timeinterval)) {
      errors.timeinterval = "Please select a time interval between bookings.";
    }

    // maxPartySize
    if (isEmpty(values.maxPartySize)) {
      errors.maxPartySize = "Please enter the maximum party size.";
    } else if (Number(values.maxPartySize) <= 0) {
      errors.maxPartySize = "Maximum party size must be greater than 0.";
    }

    // autoApprove
    if (isEmpty(values.autoApprove)) {
      errors.autoApprove = "Please select whether auto approval is enabled.";
    } else if (
      !allowedValues.autoApprove.includes(String(values.autoApprove))
    ) {
      errors.autoApprove = "Invalid auto approval value.";
    }

    // autoApproveChairLimit (only if autoApprove enabled)
    if (values.autoApprove === "Enabled") {
      if (isEmpty(values.autoApproveChairLimit)) {
        errors.autoApproveChairLimit =
          "Please enter the maximum number of guests for auto approval.";
      } else if (Number(values.autoApproveChairLimit) <= 0) {
        errors.autoApproveChairLimit =
          "Auto approval guest limit must be greater than 0.";
      }
    }

    // haveAdvance
    if (isEmpty(values.haveAdvance)) {
      errors.haveAdvance =
        "Please select whether an advance amount is required.";
    } else if (
      !allowedValues.haveAdvance.includes(String(values.haveAdvance))
    ) {
      errors.haveAdvance = "Invalid advance setting value.";
    }

    // advanceAmount + advanceType (only if advance is Yes)
    if (values.haveAdvance === "Yes") {
      if (isEmpty(values.advanceAmount)) {
        errors.advanceAmount = "Please enter an advance amount.";
      } else if (Number(values.advanceAmount) <= 0) {
        errors.advanceAmount = "Advance amount must be greater than 0.";
      }

      if (isEmpty(values.advanceType)) {
        errors.advanceType =
          "Please select how the advance amount should be calculated.";
      } else if (
        !allowedValues.advanceType.includes(String(values.advanceType))
      ) {
        errors.advanceType = "Invalid advance amount type.";
      }

      if (values.advanceType === "Chair") {
        if (isEmpty(values.minChairs)) {
          errors.minChairs =
            "Please enter the minimum chairs for advance payment.";
        } else if (Number(values.minChairs) <= 0) {
          errors.minChairs =
            "Minimum chairs for advance payment must be greater than 0.";
        }
      }
    }

    // otpVerify
    if (isEmpty(values.otpVerify)) {
      errors.otpVerify = "Please select whether OTP verification is active.";
    } else if (!allowedValues.otpVerify.includes(String(values.otpVerify))) {
      errors.otpVerify = "Invalid OTP verification value.";
    }

    // automated monthly report
    if (isEmpty(values.automatedMonthlyReport)) {
      errors.automatedMonthlyReport =
        "Please select whether automated monthly email report is enabled.";
    } else if (
      !allowedValues.automatedMonthlyReport.includes(
        String(values.automatedMonthlyReport)
      )
    ) {
      errors.automatedMonthlyReport =
        "Invalid automated monthly report value.";
    }

    if (values.automatedMonthlyReport === "Yes") {
      if (isEmpty(values.monthlyReportEmail)) {
        errors.monthlyReportEmail =
          "Please enter an email address for the monthly report.";
      } else if (
        !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(values.monthlyReportEmail))
      ) {
        errors.monthlyReportEmail =
          "Please enter a valid email address for the monthly report.";
      }
    }

    // Guest booking controls
    if (isEmpty(values.reservationGuestAllow)) {
      errors.reservationGuestAllow =
        "Please select whether guest reservations are allowed.";
    } else if (
      !allowedValues.reservationGuestAllow.includes(
        String(values.reservationGuestAllow)
      )
    ) {
      errors.reservationGuestAllow = "Invalid guest reservation allow value.";
    }

    if (isEmpty(values.reservationGuestOTPVerification)) {
      errors.reservationGuestOTPVerification =
        "Please select whether guest OTP verification is enabled.";
    } else if (
      !allowedValues.reservationGuestOTPVerification.includes(
        String(values.reservationGuestOTPVerification)
      )
    ) {
      errors.reservationGuestOTPVerification =
        "Invalid guest OTP verification value.";
    }

    return errors;
  };

  function validateReservationTiming() {
    for (const day of days) {
      const slots = reservationTiming?.[day];

      if (!Array.isArray(slots) || slots.length === 0) {
        return { isValid: false, message: "Opening/Closing time is invalid" };
      }

      const invalid = slots.some((slot) => {
        const opening = (slot?.openingTime ?? "").trim();
        const closing = (slot?.closingTime ?? "").trim();

        if (!opening || !closing) return true;
        if (closing <= opening) return true;

        return false;
      });

      if (invalid) {
        return { isValid: false, message: "Opening/Closing time is invalid" };
      }
    }

    return { isValid: true, message: "" };
  }

  const today = new Date().toISOString().slice(0, 16);

  const buildSettingsPayload = (overrides = {}) => {
    const {
      updated_at,
      id,
      shopID,
      source: _source,
      currencyDetails: _currencyDetails,
      ...rest
    } = updatedState || {};

    return {
      ...rest,
      reservationStatus:
        reservationStatus || rest.reservationStatus || "Enabled",
      viewType: viewType || rest.viewType || "formView",
      minChairs: Number(rest.minChairs) || 1,
      advanceAmount: Number(rest.advanceAmount) || 0,
      autoApproveChairLimit: Number(rest.autoApproveChairLimit) || 0,
      maxPartySize: Number(rest.maxPartySize) || 0,
      monthlyReportEmail: rest.monthlyReportEmail || "",
      automatedMonthlyReport: rest.automatedMonthlyReport || "No",
      reservationGuestAllow: rest.reservationGuestAllow || "Disabled",
      reservationGuestOTPVerification:
        rest.reservationGuestOTPVerification || "Disabled",
      source: "REACT",
      ...overrides,
    };
  };

  const updateViewType = async (value) => {
    if (!value) return;

    setViewType(value);
    setUpdatedState((prev) => ({ ...prev, viewType: value }));

    const payload = buildSettingsPayload({ viewType: value });

    await updateSettings(payload, {
      onSuccess: async (res) => {
        toast.success("Successfully changed!");
        await getSettings();
      },
      onFailed: (err) => {
        console.log("updated error", err);
        throw new Error(err);
      },
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setUpdateLoading(true);

      if (showTimings) {
        await handleShopTiming(e);
        toast.success("Timings updated successfully!");
        setTimeout(() => {
          navigate(sectionMeta.backTo, { replace: true });
        }, 1200);
        return;
      }

      if (timingChanged) {
        await handleShopTiming(e);
      }

      const errors = validateReservationSettings({
        ...updatedState,
        viewType,
      });
      if (Object.keys(errors).length > 0) {
        const values = Object.values(errors);
        values && values.length != 0 && values.map((x) => toast.error(x));
        return;
      }

      const payload = buildSettingsPayload();

      await updateSettings(payload, {
        onSuccess: async (res) => {
          toast.success("Successfully updated!");
          await getSettings();
          setTimeout(() => {
            navigate(sectionMeta.backTo, { replace: true });
          }, 1500);
        },
        onFailed: (err) => {
          console.log("updated error", err);
          throw new Error(err);
        },
      });
    } catch (error) {
      const errorMsg = error.message ?? "Update failed!.";
      console.error("Error updating reservation settings:", errorMsg);
      toast.error(errorMsg);
    } finally {
      setUpdateLoading(false);
    }
  };

  const handleShopTiming = async (e) => {
    if (e?.preventDefault) e.preventDefault();

    const { isValid, message } = validateReservationTiming();
    if (!isValid) {
      throw new Error(message ?? "Timing validation failed!");
    }

    const alteredPayload =
      reservationTiming &&
      Object.keys(reservationTiming).map((day) => {
        const slots = reservationTiming[day];

        const data = {
          day: DAY_NUM[day],
          title: day,
          slots: slots.map((slot) => ({
            start_time: slot.openingTime,
            end_time: slot.closingTime,
          })),
        };

        return data;
      });

    const payload = {
      timeslots: alteredPayload,
      update_source: "REACT",
      deviceID: getDeviceID(),
      deviceName: getDeviceName(),
    };

    await alterReservationTiming(payload, {
      onSuccess: async () => {
        await getSettings();
        setTimingChanged(false);
      },
      onFailed: (err) => {
        console.log("timing update error", err);
        throw new Error(err);
      },
    });
  };

  return (
    <Fragment>
      <MasterLayout>
        <div className="d-flex justify-content-between align-items-start flex-column flex-sm-row gap-2 mb-3 container-fluid">
          <button
            type="button"
            className="back_btn"
            onClick={() => navigate(sectionMeta.backTo, { replace: true })}
          >
            <MdKeyboardArrowLeft /> Back
          </button>
          <h1 className="rs-settings__title mb-0" style={{ fontSize: "1.25rem" }}>
            {sectionMeta.title}
          </h1>
        </div>
        <div className="container-fluid">
          {showPreferences && (
            <>
              <p className="sub_title mb-2" id="reserv_view_type">
                Reservation View Type
              </p>
              <div className="view_type_container">
                {/* FORM VIEW */}
                <div
                  className={`type_card ${
                    viewType === "formView" ? "is-active" : ""
                  }${reservSettingsLoading ? "is-disabled" : ""}`}
                >
                  <input
                    type="radio"
                    name="viewType"
                    id="viewType_form"
                    className="reserv_type_input"
                    value="form"
                    checked={viewType === "formView"}
                    onChange={(e) => updateViewType("formView")}
                    disabled={reservSettingsLoading}
                  />
                  <label htmlFor="viewType_form" className="type_card_label">
                    <span className="type_card_title">Form View</span>
                    <span className="type_card_icon">
                      <Fa.FaWpforms />
                    </span>
                    <span className="type_card_radio" aria-hidden="true"></span>
                  </label>
                </div>

                {/* CALENDAR VIEW */}
                <div
                  className={`type_card ${
                    viewType === "calendarView" ? "is-active" : ""
                  }${reservSettingsLoading ? "is-disabled" : ""}`}
                >
                  <input
                    type="radio"
                    name="viewType"
                    id="viewType_calendar"
                    className="reserv_type_input"
                    value="calendar"
                    checked={viewType === "calendarView"}
                    onChange={(e) => updateViewType("calendarView")}
                    disabled={reservSettingsLoading}
                  />
                  <label
                    htmlFor="viewType_calendar"
                    className="type_card_label"
                  >
                    <span className="type_card_title">Calendar View</span>
                    <span className="type_card_icon">
                      <Fa.FaRegCalendarAlt />
                    </span>
                    <span className="type_card_radio" aria-hidden="true"></span>
                  </label>
                </div>
              </div>
            </>
          )}
          {showTimings && (
          <>
            <p className="sub_title mb-2" id="reserv_timing">
              Reservation Timing
            </p>

            <Masonry
              columns={{ 640: 1, 768: 2, 991: 3, 1024: 3, 1280: 4 }}
              gap={16}
            >
              {days.map((day, idx) => {
                return (
                  <div className="card reserv_settings_card p-3 mb-4" key={idx}>
                    <button
                      type="button"
                      className="add_slot_btn"
                      onClick={() => addSlot(day)}
                    >
                      + Add
                    </button>
                    <p htmlFor="" className="days_label text-capitalize">
                      {day}
                    </p>
                    {reservationTiming && reservationTiming[day] ? (
                      reservationTiming[day].map((slot, idx2) => {
                        return (
                          <>
                            {/* <div
                                className="d-flex justify-content-end gap-2"
                                key={idx2}
                              >
                                <label htmlFor="" className="form-label">
                                  Status
                                </label>
                                <Switch
                                  value={
                                    slot?.status === "active" ? true : false
                                  }
                                  onChange={(e) =>
                                    handleInputChange(
                                      day,
                                      idx2,
                                      "status",
                                      e === true ? "active" : "inactive"
                                    )
                                  }
                                />
                              </div> */}
                            <div className="row" key={idx2}>
                              <div className="col-lg-6 col-sm-6 col-md-6">
                                <div className="form-group">
                                  <label htmlFor="" className="form-label">
                                    Start
                                  </label>
                                  <input
                                    type="time"
                                    name=""
                                    id=""
                                    className="form-control"
                                    value={slot.openingTime}
                                    onChange={(e) =>
                                      handleInputChange(
                                        day,
                                        idx2,
                                        "openingTime",
                                        e.target.value
                                      )
                                    }
                                  />
                                </div>
                              </div>
                              <div className="col-lg-6 col-sm-6 col-md-6">
                                <div className="form-group">
                                  <label htmlFor="" className="form-label">
                                    End
                                  </label>
                                  <input
                                    type="time"
                                    name=""
                                    id=""
                                    className="form-control"
                                    value={slot.closingTime}
                                    onChange={(e) =>
                                      handleInputChange(
                                        day,
                                        idx2,
                                        "closingTime",
                                        e.target.value
                                      )
                                    }
                                  />
                                </div>
                              </div>
                              <div className="btn_grp_new">
                                {reservationTiming[day] &&
                                  reservationTiming[day].length > 1 && (
                                    <button
                                      type="button"
                                      className="trash_slot"
                                      onClick={() => deleteSlot(day, idx2)}
                                    >
                                      <Lu.LuTrash2 />
                                    </button>
                                  )}
                                <button
                                  type="button"
                                  className="reset_btn"
                                  onClick={() => resetSlot(day, idx2)}
                                >
                                  reset
                                </button>
                              </div>
                            </div>
                          </>
                        );
                      })
                    ) : (
                      <>
                        <div className="row">
                          <div className="col-lg-6 col-sm-6 col-md-6">
                            <div className="form-group">
                              <label htmlFor="" className="form-label">
                                Start
                              </label>
                              <input
                                type="time"
                                name=""
                                id=""
                                className="form-control"
                                onChange={(e) =>
                                  handleInputChange(
                                    day,
                                    0,
                                    "start",
                                    e.target.value
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="col-lg-6 col-sm-6 col-md-6">
                            <div className="form-group">
                              <label htmlFor="" className="form-label">
                                End
                              </label>
                              <input
                                type="time"
                                name=""
                                id=""
                                className="form-control"
                                onChange={(e) =>
                                  handleInputChange(
                                    day,
                                    0,
                                    "end",
                                    e.target.value
                                  )
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                );
              })}
            </Masonry>
            <form onSubmit={handleSubmit}>
              <button
                type="submit"
                className="submit_btn mt-20"
                disabled={reservSettingsLoading || updateLoading}
              >
                {!updateLoading || !reservSettingsLoading ? (
                  "Save timings"
                ) : (
                  <PulseLoader color="#fff" size={10} />
                )}
              </button>
            </form>
          </>
          )}
          {showPreferences && (
          <>
            <p className="sub_title" id="additional_settings">
              Current Reservation Settings
            </p>
            <form className="" onSubmit={handleSubmit}>
              <div className=" h-100 radius-12">
                <Masonry
                  columns={{ 640: 1, 768: 2, 991: 3, 1024: 3, 1280: 4 }}
                  gap={15}
                  className="react-layout-masonry"
                >
                  {/* Early Bookings */}
                  <div className="card p-3">
                    <p className="sub_title">Early Bookings</p>
                    <p className="subtitle_2">
                      {" "}
                      * Select how early customers can make their booking.
                      (Administrators and Booking Managers are not restricted by
                      this setting.)
                    </p>
                    <div className="form-group position-relative">
                      <select
                        name="earlyBooking"
                        id=""
                        className="form-select"
                        onChange={onOtherSettingsChange}
                      >
                        <option
                          value="any_time"
                          selected={updatedState.earlyBooking === "0"}
                        >
                          Any Time
                        </option>
                        <option
                          value="1"
                          selected={updatedState.earlyBooking === "1"}
                        >
                          From 1 day in advance
                        </option>
                        <option
                          value="7"
                          selected={updatedState.earlyBooking === "7"}
                        >
                          From 7 day in advance
                        </option>
                        <option
                          value="14"
                          selected={updatedState.earlyBooking === "14"}
                        >
                          From 14 day in advance
                        </option>
                        <option
                          value="30"
                          selected={updatedState.earlyBooking === "30"}
                        >
                          From 30 day in advance
                        </option>
                        <option
                          value="60"
                          selected={updatedState.earlyBooking === "60"}
                        >
                          From 60 day in advance
                        </option>
                        <option
                          value="90"
                          selected={updatedState.earlyBooking === "90"}
                        >
                          From 90 day in advance
                        </option>
                      </select>
                    </div>
                  </div>
                  {/* Late Bookings */}
                  <div className="card p-3">
                    <p className="sub_title">Late Bookings</p>
                    <p className="subtitle_2">
                      {" "}
                      * Select how late customers can make their booking.
                      (Administrators and Booking Managers are not restricted by
                      this setting.)
                    </p>
                    <div className="form-group position-relative">
                      <select
                        name="lateBooking"
                        id=""
                        className="form-select"
                        onChange={onOtherSettingsChange}
                      >
                        <option
                          value="1"
                          selected={updatedState.lateBooking == "1"}
                        >
                          Up to last minute
                        </option>
                        <option
                          value="15"
                          selected={updatedState.lateBooking == "15"}
                        >
                          From 15 minutes in advance
                        </option>
                        <option
                          value="30"
                          selected={updatedState.lateBooking == "30"}
                        >
                          From 30 minutes in advance
                        </option>
                        <option
                          value="45"
                          selected={updatedState.lateBooking == "45"}
                        >
                          From 45 minutes in advance
                        </option>
                        <option
                          value="60"
                          selected={updatedState.lateBooking == "60"}
                        >
                          From 1 hour in advance
                        </option>
                        <option
                          value="240"
                          selected={updatedState.lateBooking == "240"}
                        >
                          From 4 hours in advance
                        </option>
                        <option
                          value="1440"
                          selected={updatedState.lateBooking == "1440"}
                        >
                          From 24 hours in advance
                        </option>
                      </select>
                    </div>
                  </div>
                  {/* Late Cancel */}
                  <div className="card p-3">
                    <p className="sub_title">Late Cancel</p>
                    <p className="subtitle_2">
                      {" "}
                      * Select how late customers can cancel their booking.
                      (Administrators and Booking Managers are not restricted by
                      this setting.)
                    </p>
                    <div className="form-group position-relative">
                      <select
                        name="lateCancel"
                        id=""
                        className="form-select"
                        onChange={onOtherSettingsChange}
                      >
                        <option value="">
                          please choose late cancel duration
                        </option>
                        <option
                          value="1"
                          selected={updatedState.lateCancel === "1"}
                        >
                          Up to last minute
                        </option>
                        <option
                          value="30"
                          selected={updatedState.lateCancel === "30"}
                        >
                          From 30 minutes in advance
                        </option>
                        <option
                          value="60"
                          selected={updatedState.lateCancel === "60"}
                        >
                          From 1 hour in advance
                        </option>
                        {/* <option
                              value="240"
                              selected={updatedState.lateCancel === "240"}
                            >
                              From 4 hours in advance
                            </option> */}
                        <option
                          value="1440"
                          selected={updatedState.lateCancel === "1440"}
                        >
                          From 24 hours in advance
                        </option>
                      </select>
                    </div>
                  </div>
                  {/* Time Interval */}
                  <div className="card p-3">
                    <p className="sub_title">Time Interval</p>
                    <p className="subtitle_2">
                      {" "}
                      * Select the number of minutes between each available
                      time.
                    </p>
                    <div className="form-group position-relative">
                      <select
                        name="timeinterval"
                        id=""
                        className="form-select"
                        onChange={onOtherSettingsChange}
                      >
                        <option value="">Please Choose Interval</option>
                        <option
                          value={180}
                          selected={updatedState.timeinterval == "180"}
                        >
                          Every 180 minutes
                        </option>
                        {/* <option
                              value={160}
                              selected={updatedState.timeinterval == "160"}
                            >
                              Every 160 minutes
                            </option> */}
                        <option
                          value={120}
                          selected={updatedState?.timeinterval == "120"}
                        >
                          Every 120 minutes
                        </option>
                        <option
                          value={90}
                          selected={updatedState?.timeinterval == "90"}
                        >
                          Every 90 minutes
                        </option>
                        <option
                          value={60}
                          selected={updatedState?.timeinterval == "60"}
                        >
                          Every 60 minutes
                        </option>
                        <option
                          value={30}
                          selected={updatedState?.timeinterval == "30"}
                        >
                          Every 30 minutes
                        </option>
                        <option
                          value={15}
                          selected={updatedState?.timeinterval == "15"}
                        >
                          Every 15 minutes
                        </option>
                        <option
                          value={10}
                          selected={updatedState?.timeinterval == "10"}
                        >
                          Every 10 minutes
                        </option>
                        <option
                          value={5}
                          selected={updatedState?.timeinterval == "5"}
                        >
                          Every 5 minutes
                        </option>
                      </select>
                    </div>
                  </div>
                  {/* Party Size */}
                  <div className="card p-3">
                    <label htmlFor="" className="form-label">
                      Party Size
                    </label>
                    <p className="subtitle_2">
                      {" "}
                      * Size of the party (Chairs limit).
                    </p>
                    <input
                      type="number"
                      name="maxPartySize"
                      id=""
                      className="form-control"
                      min={1}
                      onChange={onOtherSettingsChange}
                      value={
                        updatedState?.maxPartySize &&
                        typeof updatedState?.maxPartySize === "string"
                          ? Number(updatedState?.maxPartySize)
                          : updatedState?.maxPartySize ?? 0
                      }
                    />
                  </div>
                  {/* Advance Approval */}
                  <div className="card p-3">
                    <p className="sub_title">Advance Approval</p>
                    <span className="subtitle_2">
                      * Enable this to handle Advance Amount.
                    </span>
                    <div className="d-flex gap-4">
                      <div className="form-check">
                        <input
                          className="form-check-input m-1"
                          type="radio"
                          name="haveAdvance"
                          id="flexRadioDefault4"
                          checked={updatedState?.haveAdvance === "Yes"}
                          onChange={onOtherSettingsChange}
                          value="Yes"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="flexRadioDefault4"
                        >
                          Yes
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input m-1"
                          type="radio"
                          name="haveAdvance"
                          id="flexRadioDefault3"
                          checked={updatedState?.haveAdvance === "No"}
                          onChange={onOtherSettingsChange}
                          value="No"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="flexRadioDefault3"
                        >
                          No
                        </label>
                      </div>
                    </div>
                    {updatedState?.haveAdvance === "Yes" ? (
                      <>
                        <label className="form-label mt-4 mb-0">
                          Advance Amount
                        </label>
                        <p className="subtitle_2">
                          * Enter the amount customers must pay in advance for
                          their booking to be confirmed automatically.
                        </p>
                        <input
                          type="number"
                          name="advanceAmount"
                          id="advanceAmount"
                          className="form-control"
                          min={1}
                          value={updatedState?.advanceAmount}
                          onChange={onOtherSettingsChange}
                        />
                        <br />
                        <label className="form-label mt-4 mb-0">
                          Amount Type
                        </label>
                        <p className="subtitle_2">
                          * Select the basis on which the advance amount is
                          calculated.
                        </p>
                        <select
                          name="advanceType"
                          id="advanceType"
                          className="form-select"
                          onChange={onOtherSettingsChange}
                          value={updatedState?.advanceType || "Total"}
                        >
                          <option value="Total">Total</option>
                          <option value="Table">Per Table</option>
                          <option value="Chair">Per Chair</option>
                        </select>
                        {updatedState?.advanceType === "Chair" && (
                          <>
                            <label className="form-label mt-4 mb-0">
                              Minimum Chairs for Advance Payment
                            </label>
                            <p className="subtitle_2">
                              * Advance payment applies when the party size is
                              at least this many chairs.
                            </p>
                            <input
                              type="number"
                              name="minChairs"
                              id="minChairs"
                              className="form-control"
                              min={1}
                              value={updatedState?.minChairs ?? 1}
                              onChange={onOtherSettingsChange}
                            />
                          </>
                        )}
                      </>
                    ) : (
                      <>
                        <br />
                        <p className="sub_title">OTP Verify</p>
                        <span className="subtitle_2">
                          * Enable this option to use OTP verification for the
                          book a reservation.
                        </span>
                        <div className="d-flex gap-4">
                          <div className="form-check">
                            <input
                              className="form-check-input m-1"
                              type="radio"
                              name="otpVerify"
                              id="flexRadioDefault5"
                              checked={updatedState?.otpVerify === "Active"}
                              onChange={onOtherSettingsChange}
                              value="Active"
                            />
                            <label
                              className="form-check-label"
                              htmlFor="flexRadioDefault5"
                            >
                              Active
                            </label>
                          </div>
                          <div className="form-check">
                            <input
                              className="form-check-input m-1"
                              type="radio"
                              name="otpVerify"
                              id="flexRadioDefault6"
                              checked={updatedState?.otpVerify === "Inactive"}
                              onChange={onOtherSettingsChange}
                              value="Inactive"
                            />
                            <label
                              className="form-check-label"
                              htmlFor="flexRadioDefault6"
                            >
                              Inactive
                            </label>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                  {/* Auto Approval */}
                  <div className="card p-3">
                    <p className="sub_title">Auto Approval</p>
                    <span className="subtitle_2">
                      * Enable this option if you want bookings to be approved
                      automatically.
                    </span>
                    <div className="d-flex gap-4">
                      <div className="form-check">
                        <input
                          className="form-check-input m-1"
                          type="radio"
                          name="autoApprove"
                          id="flexRadioDefault1"
                          checked={updatedState?.autoApprove === "Enabled"}
                          onChange={onOtherSettingsChange}
                          value="Enabled"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="flexRadioDefault1"
                        >
                          Yes
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input m-1"
                          type="radio"
                          name="autoApprove"
                          id="flexRadioDefault2"
                          checked={updatedState?.autoApprove === "Disabled"}
                          onChange={onOtherSettingsChange}
                          value="Disabled"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="flexRadioDefault2"
                        >
                          No
                        </label>
                      </div>
                    </div>
                    {updatedState?.autoApprove === "Enabled" && (
                      <>
                        <label className="form-label mt-4 mb-0">
                          Chairs Limit
                        </label>
                        <p className="subtitle_2">
                          * Enter the maximum number of guests per booking that
                          will be automatically approved.
                        </p>
                        <input
                          type="number"
                          name="autoApproveChairLimit"
                          id="autoApproveChairLimit"
                          className="form-control"
                          value={updatedState?.autoApproveChairLimit}
                          onChange={onOtherSettingsChange}
                        />
                      </>
                    )}
                  </div>
                  {/* Automated monthly email report */}
                  <div className="card p-3">
                    <p className="sub_title">Automated monthly email report</p>
                    <span className="subtitle_2">
                      * Receive the Table Reservation Monthly Analytics Report
                      by email on the 1st of each month (for the previous
                      month).
                    </span>
                    <div className="d-flex gap-4">
                      <div className="form-check">
                        <input
                          className="form-check-input m-1"
                          type="radio"
                          name="automatedMonthlyReport"
                          id="automatedMonthlyReportYes"
                          checked={
                            updatedState?.automatedMonthlyReport === "Yes"
                          }
                          onChange={onOtherSettingsChange}
                          value="Yes"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="automatedMonthlyReportYes"
                        >
                          Yes
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input m-1"
                          type="radio"
                          name="automatedMonthlyReport"
                          id="automatedMonthlyReportNo"
                          checked={
                            updatedState?.automatedMonthlyReport === "No" ||
                            !updatedState?.automatedMonthlyReport
                          }
                          onChange={onOtherSettingsChange}
                          value="No"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="automatedMonthlyReportNo"
                        >
                          No
                        </label>
                      </div>
                    </div>
                    {updatedState?.automatedMonthlyReport === "Yes" && (
                      <>
                        <label className="form-label mt-4 mb-0">
                          Email address for report
                        </label>
                        <p className="subtitle_2">
                          * Enter a valid email address to receive the monthly
                          analytics report.
                        </p>
                        <input
                          type="email"
                          name="monthlyReportEmail"
                          id="monthlyReportEmail"
                          className="form-control"
                          placeholder="name@example.com"
                          value={updatedState?.monthlyReportEmail || ""}
                          onChange={onOtherSettingsChange}
                        />
                      </>
                    )}
                  </div>
                  {/* Guest reservation allow */}
                  <div className="card p-3">
                    <p className="sub_title">Allow Guest Reservations</p>
                    <span className="subtitle_2">
                      * Enable this to allow guests (without an account) to make
                      reservations.
                    </span>
                    <div className="d-flex gap-4">
                      <div className="form-check">
                        <input
                          className="form-check-input m-1"
                          type="radio"
                          name="reservationGuestAllow"
                          id="reservationGuestAllowEnabled"
                          checked={
                            updatedState?.reservationGuestAllow === "Enabled"
                          }
                          onChange={onOtherSettingsChange}
                          value="Enabled"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="reservationGuestAllowEnabled"
                        >
                          Enabled
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input m-1"
                          type="radio"
                          name="reservationGuestAllow"
                          id="reservationGuestAllowDisabled"
                          checked={
                            updatedState?.reservationGuestAllow ===
                              "Disabled" ||
                            !updatedState?.reservationGuestAllow
                          }
                          onChange={onOtherSettingsChange}
                          value="Disabled"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="reservationGuestAllowDisabled"
                        >
                          Disabled
                        </label>
                      </div>
                    </div>
                  </div>
                  {/* Guest OTP verification */}
                  <div className="card p-3">
                    <p className="sub_title">Guest OTP Verification</p>
                    <span className="subtitle_2">
                      * Require OTP verification for guest reservation bookings.
                    </span>
                    <div className="d-flex gap-4">
                      <div className="form-check">
                        <input
                          className="form-check-input m-1"
                          type="radio"
                          name="reservationGuestOTPVerification"
                          id="reservationGuestOTPEnabled"
                          checked={
                            updatedState?.reservationGuestOTPVerification ===
                            "Enabled"
                          }
                          onChange={onOtherSettingsChange}
                          value="Enabled"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="reservationGuestOTPEnabled"
                        >
                          Enabled
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input m-1"
                          type="radio"
                          name="reservationGuestOTPVerification"
                          id="reservationGuestOTPDisabled"
                          checked={
                            updatedState?.reservationGuestOTPVerification ===
                              "Disabled" ||
                            !updatedState?.reservationGuestOTPVerification
                          }
                          onChange={onOtherSettingsChange}
                          value="Disabled"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="reservationGuestOTPDisabled"
                        >
                          Disabled
                        </label>
                      </div>
                    </div>
                  </div>
                </Masonry>
              </div>
              <button
                type="submit"
                className="submit_btn mt-20"
                disabled={reservSettingsLoading || updateLoading}
              >
                {!updateLoading || !reservSettingsLoading ? (
                  "Submit"
                ) : (
                  <PulseLoader color="#fff" size={10} />
                )}
              </button>
            </form>
          </>
          )}
        </div>
      </MasterLayout>
    </Fragment>
  );
}

export default EditReservationSettings;
